/* eslint-disable no-debugger */
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Icon, { ExclamationCircleOutlined } from "@/utils/antdIcon";
import { Collapse, Modal } from "antd";
import { BatchDownloadItem, ErrorCode, Status } from "./type";
import {
  getSuccessDownloadTaskCount,
  getGlobalStatus,
  checkDownloadError
} from "./BasisComponents/utils";
import PanelHeader from "./BasisComponents/PanelHeader";
import Header from "./BasisComponents/Header";
import List from "./BasisComponents/Main";
import { CancelIcon, UpIcon } from "./BasisComponents/Icons";
import BatchDownloadController from "./BatchDownloadController";
import events from "../../context/events";
import { btnAction } from "./config/btn.aciton";
import { useLocation } from "react-router-dom";
import "./index.less";
import GlobalContext from "@/context/GlobalContext";

interface IProps {
  className?: string;
}

const { Panel } = Collapse;
let index = 0;
const DownloadCollapsePanel = (props: IProps) => {
  const { className = "" } = props;
  const location = useLocation();
  const [activeKey, setActiveKey] = useState<any>();
  const [list, setList] = useState<BatchDownloadItem[]>([]);
  const DownloadService = BatchDownloadController.getInstance();
  const { onLine } = useContext(GlobalContext);
  DownloadService.proxy(setList);
  // 添加任务&开始任务下载
  const addTaskList = useCallback(
    (newTaskList) => {
      // console.log(newTaskList, 'newTaskListnewTaskListnewTaskList=>');
      DownloadService.addTask([...newTaskList], () => {
        // console.log(
        //     DownloadService.getTaskQueue(),
        //     'addTaskListaddTaskListaddTaskListaddTaskListaddTaskList'
        // );
        setList([...DownloadService.getTaskQueue()]);
        setActiveKey("download");
        events.emit("handleUploadPanel", true);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const handleDownloadPanel = useCallback((isUploadExpand) => {
    isUploadExpand && setActiveKey("");
  }, []);
  useEffect(() => {
    events.on("handleDownload:addTaskList", addTaskList);
    events.on("handleDownloadPanel", handleDownloadPanel);
    return () => {
      events.removeListener("handleDownload:addTaskList", addTaskList);
      events.removeListener("handleDownloadPanel", handleDownloadPanel);
    };
  }, [addTaskList, handleDownloadPanel]);
  const cancelPanel = useCallback(
    () => {
      index = 0;
      setList([]);
      setActiveKey("");
      DownloadService.clearTaskAll();
      // removeNode();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [list]
  );
  // 关闭面板和折叠面板
  const genExtra: any = useCallback(() => {
    return (
      <div>
        <span
          className={
            activeKey === "download"
              ? "collapse-icon collapse-down-icon"
              : "collapse-icon collapse-up-icon"
          }
        >
          <Icon component={UpIcon} />
        </span>
        <span
          className="collapse-cancel-icon"
          onClick={(event: any) => {
            event.stopPropagation();
            if (
              list.some(
                (item: BatchDownloadItem) =>
                  item.status === Status.PROGRESS || item.status === Status.WAITING
              )
            ) {
              Modal.confirm({
                title: "取消下载",
                icon: <ExclamationCircleOutlined />,
                content: "下载尚未完成，要取消所有的下载吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: () => {
                  cancelPanel();
                }
              });
              return;
            }
            cancelPanel();
            // cancelPanel(event);
          }}
        >
          <Icon component={CancelIcon} />
        </span>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, list]);
  const { currentSuccessTaskCount, totalTaskCount, gloadlStatus } = useMemo(() => {
    let currentSuccessTaskCount = getSuccessDownloadTaskCount(list);
    let totalTaskCount = list.length;
    let gloadlStatus = getGlobalStatus(list);
    return { currentSuccessTaskCount, totalTaskCount, gloadlStatus };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, onLine]);
  if (!location.pathname.includes("/joyspace")) {
    return null;
  }
  return (
    <Collapse
      className={className + " collapse-box"}
      bordered={false}
      accordion={true}
      activeKey={activeKey ? [activeKey] : []}
      onChange={(key) => {
        // console.log(key, 'keykeykeykeykeykeykey');
        setActiveKey(key);
        events.emit("handleUploadPanel", Boolean(key));
      }}
    >
      {/* 批量下载 */}
      {list.length > 0 && (
        <Panel
          showArrow={false}
          header={
            <PanelHeader
              status={gloadlStatus}
              currentSuccessTaskCount={currentSuccessTaskCount}
              totalTaskCount={totalTaskCount}
            />
          }
          key="download"
          extra={genExtra()}
        >
          <Header
            status={gloadlStatus}
            currentSuccessTaskCount={currentSuccessTaskCount}
            totalTaskCount={totalTaskCount}
            handleCancelAll={() => {
              DownloadService.handleTaskCancelAll();
            }}
            handleRetryAll={() => {
              DownloadService.handleTaskRetryAll(index++);
            }}
          />
          <List
            list={list}
            callback={(item: BatchDownloadItem) => {
              // item.options.onStarted(item);
              let applyFn = Status.ERROR;
              if (item.status === Status.PROGRESS || item.status === Status.WAITING) {
                applyFn = Status.CANCEL;
              } else if (item.status === Status.CANCEL || item.status === Status.RETRY) {
                applyFn = Status.RETRY;
              } else if (item.status === Status.SUCCESS) {
                applyFn = Status.SUCCESS;
              } else {
                applyFn = Status.ERROR;
              }
              btnAction[applyFn](DownloadService, item, onLine ? index++ : index);
            }}
          />
        </Panel>
      )}
    </Collapse>
  );
};

export default DownloadCollapsePanel;
